export default "__VITE_ASSET__CG$_q$O5__"